/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbExportGridDto } from './FcbExportGridDto';
import {
    FcbExportGridDtoFromJSON,
    FcbExportGridDtoFromJSONTyped,
    FcbExportGridDtoToJSON,
} from './FcbExportGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbExportGridDtoPaginatedResults
 */
export interface FcbExportGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbExportGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbExportGridDto>}
     * @memberof FcbExportGridDtoPaginatedResults
     */
    results?: Array<FcbExportGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbExportGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbExportGridDtoPaginatedResults interface.
 */
export function instanceOfFcbExportGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportGridDtoPaginatedResultsFromJSON(json: any): FcbExportGridDtoPaginatedResults {
    return FcbExportGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbExportGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbExportGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbExportGridDtoPaginatedResultsToJSON(value?: FcbExportGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbExportGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

